import { Pipe, PipeTransform } from '@angular/core';

export interface PriceModel {
  amount: number;
  currency: string;
}

@Pipe({
  name: 'formatPrice',
  pure: true,
})
export class FormatPricePipe implements PipeTransform {
  /**
   * Transforms a price (number or PriceModel) into a formatted price string
   * @param price - Either a number (amount in cents) or a PriceModel object
   * @param currency - Currency string (only used when price is a number)
   * @returns Formatted price string
   */
  transform(price: number | PriceModel | null | undefined, currency?: string): string {
    // Handle PriceModel object
    if (price && typeof price === 'object' && 'amount' in price && 'currency' in price) {
      return `${price.amount / 100} ${price.currency}`;
    }

    // Handle number input (original behavior)
    if (typeof price === 'number') {
      const formattedAmount = `${price / 100}`.replace('.', ',');
      return currency ? `${formattedAmount} ${currency}` : `${formattedAmount} €`;
    }

    return '-';
  }
}
